<div class="ui-g invoice-section-full-view" *ngIf="invoice">
  <div class="ui-g-12" style="position: relative; padding: 0">
    <div class="ui-grid-row invoice-section-buttons">
      <div class="ui-g-12" style="text-align: right">
        <button
          pButton
          type="button"
          style="width: 150px"
          label="Print"
          class="ui-button"
          (click)="print()"
        ></button>
        <button
          pButton
          type="button"
          style="width: 150px"
          label="Hide"
          class="ui-button ui-button-danger"
          (click)="hide()"
        ></button>
      </div>
    </div>

    <div class="invoice-section-print">
      <div *ngIf="invoice.invoiceCancelledOn" class="invoice-view-stamp">CANCELLED</div>

      <div class="ui-grid-row">
        <div class="ui-g-6 ui-sm-12">
          <div class="invoice-view-invoicenum">Invoice #{{ invoice.invoiceNumber }}</div>
          <div class="invoice-view-field">
            Invoice date: {{ invoice.invoiceDate | datex : 'DD/MM/YYYY' }}
          </div>
        </div>
        <div class="ui-g-6 ui-sm-12">
          <div style="text-align: right">
            <div class="invoice-view-orgname">{{ invoice.supplierName }}</div>
            <div *ngIf="invoice.supplierAddress1" class="invoice-view-field">
              {{ invoice.supplierAddress1 }}
            </div>
            <div *ngIf="invoice.supplierAddress2" class="invoice-view-field">
              {{ invoice.supplierAddress2 }}
            </div>
            <div *ngIf="invoice.supplierAddress3" class="invoice-view-field">
              {{ invoice.supplierAddress3 }}
            </div>
            <div *ngIf="invoice.supplierAddressCity" class="invoice-view-field">
              {{ invoice.supplierAddressCity }}
            </div>
            <div *ngIf="invoice.supplierAddressPostcode" class="invoice-view-field">
              {{ invoice.supplierAddressPostcode | postcode }}
            </div>
            <div></div>
            <div class="invoice-view-field">{{ invoice.supplierPhone }}</div>
          </div>
        </div>
      </div>

      <div *ngIf="engineius" class="ui-grid-row" style="padding-bottom: 20px">
        <div class="ui-g-12">
          <div class="invoice-view-orgname">Invoice To</div>
          <div class="invoice-view-orgname">{{ engineius.name }}</div>
          <div *ngIf="engineius.addressLine1" class="invoice-view-field">
            {{ engineius.addressLine1 }}
          </div>
          <div *ngIf="engineius.addressLine2" class="invoice-view-field">
            {{ engineius.addressLine2 }}
          </div>
          <div *ngIf="engineius.addressLine3" class="invoice-view-field">
            {{ engineius.addressLine3 }}
          </div>
          <div *ngIf="engineius.town" class="invoice-view-field">{{ engineius.town }}</div>
          <div *ngIf="engineius.postcode" class="invoice-view-field">
            {{ engineius.postcode | postcode }}
          </div>
        </div>
      </div>

      <div *ngIf="tlines" class="ui-g-12" style="overflow-x: auto">
        <table class="invoice-view-tlines" cellpadding="0" cellspacing="0">
          <thead>
            <tr>
              <th>Transaction Number</th>
              <th>Account Code</th>
              <th>Description</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of tlines">
              <td>{{ item.jobNumber ? item.jobNumber : item.transactionNumber }}</td>
              <td>{{ item.accountCode }}</td>
              <td>{{ item.description }}</td>
              <td>{{ item.amount | currency : 'GBP' : 'symbol' : '1.2-2' }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div style="width: 100%">
        <div class="pull-right ui-sm-12 ui-g-3">
          <table class="invoice-view-totals" cellpadding="0" cellspacing="0">
            <tr>
              <td>Sub Total (VAT)</td>
              <td>{{ invoice.subtotalVAT | currency : 'GBP' : 'symbol' : '1.2-2' }}</td>
            </tr>
            <tr>
              <td>Sub Total (No-VAT)</td>
              <td>{{ invoice.subtotalNoVAT | currency : 'GBP' : 'symbol' : '1.2-2' }}</td>
            </tr>
            <tr *ngIf="invoice.vatNumber">
              <td>VAT</td>
              <td>{{ invoice.vat | currency : 'GBP' : 'symbol' : '1.2-2' }}</td>
            </tr>
            <tr>
              <td class="cell-bold">TOTAL</td>
              <td>{{ invoice.total | currency : 'GBP' : 'symbol' : '1.2-2' }}</td>
            </tr>
          </table>
        </div>
      </div>

      <div class="ui-grid-row invoice-view-area-vatnumber">
        <div class="ui-g-12" style="text-align: center">
          <span *ngIf="invoice.companyRegistrationNumber"
            >Registration Number: {{ invoice.companyRegistrationNumber }}</span
          >
          <span
            *ngIf="invoice.companyRegistrationNumber && invoice.vatNumber"
            style="display: inline-block; width: 30px"
          ></span>
          <span *ngIf="invoice.vatNumber">VAT Number: {{ invoice.vatNumber }}</span>
        </div>
      </div>

      <div *ngIf="invoice.invoiceCancelledOn" class="invoice-view-area-cancelled ui-grid-row">
        <div class="ui-g-12">
          <div>Cancelled: {{ invoice.invoiceCancelledOn | datex : 'DD/MM/YYYY' }}</div>
          <div>Reason: {{ invoice.invoiceCancelledReason }}</div>
        </div>
      </div>
    </div>
  </div>
</div>
